var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartstroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35378 21.1905C9.93048 21.1905 10.398 20.76 10.398 20.229C10.398 19.698 9.93048 19.2676 9.35378 19.2676C8.77708 19.2676 8.30957 19.698 8.30957 20.229C8.30957 20.76 8.77708 21.1905 9.35378 21.1905Z",
    stroke: "#EFC80C",
    strokeWidth: 1.92292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8401 21.1905C21.4168 21.1905 21.8843 20.76 21.8843 20.229C21.8843 19.698 21.4168 19.2676 20.8401 19.2676C20.2634 19.2676 19.7959 19.698 19.7959 20.229C19.7959 20.76 20.2634 21.1905 20.8401 21.1905Z",
    stroke: "#EFC80C",
    strokeWidth: 1.92292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H5.17684L7.97533 13.874C8.07082 14.3166 8.33235 14.7143 8.71416 14.9973C9.09596 15.2802 9.5737 15.4306 10.0638 15.4219H20.2135C20.7035 15.4306 21.1813 15.2802 21.5631 14.9973C21.9449 14.7143 22.2064 14.3166 22.3019 13.874L23.9726 5.80731H6.22105",
    stroke: "#EFC80C",
    strokeWidth: 1.92292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartstroke);
export default __webpack_public_path__ + "static/media/cartstroke.d0f9ca0c5d9d07ef01669ce0b82c2d5c.svg";
export { ForwardRef as ReactComponent };